import { render } from "./ContactUs.vue?vue&type=template&id=40248454&scoped=true"
import script from "./ContactUs.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactUs.vue?vue&type=script&setup=true&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=40248454&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\agrifutura\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40248454"],['__file',"resources/js/frontend/components/ContactUs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40248454"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40248454', __exports__)) {
    console.log('reload')
    api.reload('40248454', __exports__)
  }
  
  module.hot.accept("./ContactUs.vue?vue&type=template&id=40248454&scoped=true", () => {
    console.log('re-render')
    api.rerender('40248454', render)
  })

}


export default __exports__